module.exports = __webpack_public_path__ + "img/before8.a5b99ded.png";